/*
 * @Author       : yiyang
 * @Date         : 2020-09-02 16:19:03
 * @LastEditors  : yiyang
 * @LastEditTime : 2020-12-15 19:00:40
 * @PRD          : 
 * @Description  : 
 * @FilePath     : /work/yit_fe_shangbo/src/routes/cover/index.js
 * @URL          : 
 */
import React from "react"
import { useHistory } from 'react-router-dom'
import coverJson from "assets/data/cover.json"
import NETImage from 'components/net-image'
import useShare from "utils/wechat/useShare"
import useConfig from "utils/wechat/useConfig"
import config from "config/default"
// import Item from "./Item"
import { GRAPHIC_PATH } from 'routes/path'
import './index.css'

/**
 * 封面列表
 */
export default function CoverRoute() {
    let { years, shareInfo = {} } = coverJson;
    let { title } = shareInfo;
    const history = useHistory();

    const { documentTitle/*, documentDescription, cdnUrl*/ } = config;
    const shareConfig = {
        // imgUrl: cdnUrl + '/logo.jpg',
        title: title || documentTitle,
        // desc: documentDescription,
    }
    
    const { wechatReady } = useConfig();
    useShare(wechatReady, shareConfig);

    document.title = title || documentTitle;

    const onSelect = (item) => {
        history.push(GRAPHIC_PATH(item.linkUrl))
    }
    
    return (
        <div className="cover_content">
            {years && years.length && years.map((mon, m) => (
                // <Item  key={m} item={mon} theme={} />
                <div className="year" key={m}>
                    <div className="year_title">{mon.title}</div>
                    <div className="year_list">
                        {mon.listInfo.map((item, i) => (
                            <div className="cover_item" key={`${m}_${i}`} onClick={()=>onSelect(item)}>
                                <div className="img_box">
                                    <NETImage
                                        prefix={'covers/'}
                                        useAutoHeight
                                        src={item.imgUrl}
                                        className='img'
                                    />
                                </div>
                                <div className="name">{item.title}</div>
                            </div>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    )
}